import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateNotificationSubscriptionByDossierIdController.php
* @route '/api/update-notification-subscriptions/{id}'
*/
const UpdateNotificationSubscriptionByDossierIdController = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateNotificationSubscriptionByDossierIdController.url(args, options),
    method: 'put',
})

UpdateNotificationSubscriptionByDossierIdController.definition = {
    methods: ["put"],
    url: '/api/update-notification-subscriptions/{id}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateNotificationSubscriptionByDossierIdController.php
* @route '/api/update-notification-subscriptions/{id}'
*/
UpdateNotificationSubscriptionByDossierIdController.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return UpdateNotificationSubscriptionByDossierIdController.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/UpdateNotificationSubscriptionByDossierIdController.php
* @route '/api/update-notification-subscriptions/{id}'
*/
UpdateNotificationSubscriptionByDossierIdController.put = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateNotificationSubscriptionByDossierIdController.url(args, options),
    method: 'put',
})

export default UpdateNotificationSubscriptionByDossierIdController